//TODO: this might not be needed but if it is, then update it to be dynmaic instead of the hard corded values. 

import * as React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

import NotificationsMenu from './NotificationsMenu';
import MenuContent from './MenuContent';
import OptionsMenu from './OptionsMenu';
import { getInitials, getUserAffiliationLabel, getUserDisplayName } from '../utils/userProfile';

function SideMenuMobile({ open, toggleDrawer }) {
  const user = useSelector((state) => state.auth.user);
  const partnerProfile = useSelector((state) => state.auth.partnerProfile);
  const displayName = getUserDisplayName(user, partnerProfile);
  const affiliationLabel = getUserAffiliationLabel(partnerProfile);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={displayName}
              sx={{ width: 24, height: 24 }}
            >
              {getInitials(displayName)}
            </Avatar>
            <Stack sx={{ minWidth: 0 }}>
              <Typography component="p" variant="h6" noWrap>
                {displayName}
              </Typography>
              <Typography variant="caption" color="text.secondary" noWrap>
                {affiliationLabel}
              </Typography>
            </Stack>
          </Stack>
          <NotificationsMenu />
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
          <Divider />
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
